import { render, staticRenderFns } from "./TableCartItem.vue?vue&type=template&id=ec24bc4a&scoped=true"
import script from "./TableCartItem.vue?vue&type=script&lang=js"
export * from "./TableCartItem.vue?vue&type=script&lang=js"
import style0 from "./TableCartItem.vue?vue&type=style&index=0&id=ec24bc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24bc4a",
  null
  
)

export default component.exports